import React from 'react';
import { User } from '../../util/Types/User';
import IntegrationCatalog from './catalog/IntegrationCatalog';

type Props = {
  authUser: User;
  setSelectedMenuItem?:
    | React.Dispatch<React.SetStateAction<string>>
    | undefined;
};

const Integrations = (_: Props) => {
  return <IntegrationCatalog />;
};

export default Integrations;
